var _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgNewspaperClippingIcon(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 19,
    height: 19,
    viewBox: "0 0 19 19",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "_9025772_newspaper_clipping_icon",
    "data-name": "9025772_newspaper_clipping_icon",
    transform: "translate(-0.411 -0.411)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_5833",
    "data-name": "Rectangle 5833",
    width: 19,
    height: 19,
    transform: "translate(0.411 0.411)",
    fill: "none"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_20273",
    "data-name": "Path 20273",
    d: "M32,60.262V48.584A.584.584,0,0,1,32.584,48H45.43a.584.584,0,0,1,.584.584V60.262l-2.336-1.168-2.336,1.168-2.336-1.168-2.336,1.168-2.336-1.168Z",
    transform: "translate(-29.596 -44.428)",
    fill: "none",
    stroke: "#000",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1
  }), /*#__PURE__*/React.createElement("line", {
    id: "Line_514",
    "data-name": "Line 514",
    x2: 3,
    transform: "translate(10.411 8.411)",
    fill: "none",
    stroke: "#000",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1
  }), /*#__PURE__*/React.createElement("line", {
    id: "Line_515",
    "data-name": "Line 515",
    x2: 3,
    transform: "translate(10.411 10.411)",
    fill: "none",
    stroke: "#000",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_5834",
    "data-name": "Rectangle 5834",
    width: 3,
    height: 6,
    transform: "translate(5.411 6.411)",
    fill: "none",
    stroke: "#000",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgNewspaperClippingIcon);
export default __webpack_public_path__ + "static/media/newspaper_clipping_icon.c64b75e457bcb55fdff096e063297d05.svg";
export { ForwardRef as ReactComponent };